module.exports = __webpack_public_path__ + "img/img22.784531d1.svg";